// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".promocode-colors__text{margin-top:12px;margin-bottom:8px;color:var(--7k9zs9);font-size:14px;font-weight:300;line-height:20px}.promocode-colors__list{display:flex}.promocode-colors__item{width:20px;height:20px;margin-right:6px;border-radius:50%}", ""]);
// Exports
module.exports = exports;
